import {format} from 'date-fns';

const mapper = {};

mapper.mapOrders = (orders) => {
	const mappedOrders = [];

	orders.forEach(order => {
		if (order.order.type === 1) {
			order = mapper.mapBol(order);
		} else if (order.order.type === 2) {
			order = mapper.mapLightspeed(order);
		}

		mappedOrders.push(order);
	});

	return mappedOrders;
}

mapper.mapOrder = (order) => {
	if (order.order.type === 1) {
		return mapper.mapBol(order);
	} else if (order.order.type === 2) {
		return mapper.mapLightspeed(order);
	}
}

mapper.mapBol = (orderData) => {
	const order = {};
	order.hide = false;

	order.order = {};
	order.order.id = orderData.order.id;
	order.order.type = orderData.order.type;
	order.order.is_bol_vvb_order = orderData.order.is_bol_vvb_order;
	order.order.type_id = orderData.order.bol_order_id;
	order.order.type_id_visible = orderData.order.bol_order_id;
	order.order.type_email_subject = `Bestelling ${order.order.type_id_visible} via bol.com`;
	order.order.status = orderData.order.status;
	order.order.dropship = orderData.order.dropship;
	order.order.dropship_reference = orderData.order.dropship_reference;

	if (orderData.items[0].fulfilment_latest_delivery_date !== null) {
		let fulfilmentLatestDeliveryDate = new Date(orderData.items[0].fulfilment_latest_delivery_date);
		fulfilmentLatestDeliveryDate = format(fulfilmentLatestDeliveryDate, 'yyyy-MM-dd');

		order.order.latest_delivery_date = fulfilmentLatestDeliveryDate;
	} else {
		order.order.latest_delivery_date = null;
	}

	if (orderData.items[0].fulfilment_exact_delivery_date !== null) {
		let fulfilmentExactDeliveryDate = new Date(orderData.items[0].fulfilment_exact_delivery_date);
		fulfilmentExactDeliveryDate = format(fulfilmentExactDeliveryDate, 'yyyy-MM-dd');

		order.order.exact_delivery_date = fulfilmentExactDeliveryDate;
	} else {
		order.order.exact_delivery_date = null;
	}

	order.order.order_placed_date_time = orderData.order.order_placed_date_time;
	order.order.sendcloud = orderData.order.sendcloud;
	order.order.sendcloud_parcel_id = orderData.order.sendcloud_parcel_id;
	order.order.sendcloud_tracking = orderData.order.sendcloud_tracking;
	order.order.sendcloud_method = orderData.order.sendcloud_method;
	order.order.order_price = orderData.order.order_price;
	order.order.updated_at = orderData.order.updated_at;
	order.order.order_commission = orderData.order.order_commission;

	order.shipping = {};
	order.shipping.company = orderData.shipping.company;
	order.shipping.full_name = orderData.shipping.full_name;
	order.shipping.full_address = orderData.shipping.full_address;
	order.shipping.zip_code = orderData.shipping.zip_code;
	order.shipping.city = orderData.shipping.city;
	order.shipping.country_code = orderData.shipping.country_code;
	order.shipping.email = orderData.shipping.email;

	order.billing = {};
	order.billing.company = orderData.billing.company;
	order.billing.full_name = orderData.billing.full_name;
	order.billing.full_address = orderData.billing.full_address;
	order.billing.zip_code = orderData.billing.zip_code;
	order.billing.city = orderData.billing.city;
	order.billing.country_code = orderData.billing.country_code;
	order.billing.email = orderData.billing.email;

	order.items = [];

	orderData.items.forEach(orderItemData => {
		const orderItem = {};
		orderItem.id = orderItemData.id
		orderItem.transport_code = orderItemData.transport_code
		orderItem.transport_track_and_trace = orderItemData.transport_track_and_trace
		orderItem.transport_status = orderItemData.transport_status
		orderItem.condition = orderItemData.bol_offer_condition;
		orderItem.ean = orderItemData.product_ean;
		orderItem.quantity = orderItemData.quantity;
		if(orderItemData.bundle_quantity){
			orderItem.bundle_quantity = orderItemData.bundle_quantity;
		} else {
			orderItem.bundle_quantity = 1;
		}
		if(orderItemData.weight_in_gram){
			orderItem.weight_in_gram = orderItemData.weight_in_gram;
		} else {
			orderItem.weight_in_gram = null;
		}
		orderItem.unit_price = orderItemData.unit_price;
		orderItem.title = orderItemData.product_title;
		orderItem.reference = orderItemData.bol_offer_reference;
		orderItem.location = orderItemData.offer_location;
		orderItem.package_id = orderItemData.offer_package_id;
		orderItem.unit_commission = orderItemData.unit_commission;
		orderItem.expiry_date = orderItemData.fulfilment_expiry_date;
		orderItem.latest_delivery_date = orderItemData.fulfilment_latest_delivery_date;
		orderItem.cancellation_request = orderItemData.cancellation_request;
		orderItem.cancellation_request_status = orderItemData.cancellation_request_status;
		orderItem.fulfilment_distribution_party = orderItemData.fulfilment_distribution_party;
		orderItem.fulfilment_method = orderItemData.fulfilment_method;

		order.items.push(orderItem);
	});

	order.delivery_options = [];

	if (orderData.order.order_delivery_options && Array.isArray(orderData.order.order_delivery_options)) {
		orderData.order.order_delivery_options.forEach(orderDeliveryOptionData => {
			const orderDeliveryOption = {};
			orderDeliveryOption.id = orderDeliveryOptionData.id;
			orderDeliveryOption.used_for_shipping = orderDeliveryOptionData.used_for_shipping;
			orderDeliveryOption.shipping_label_id = orderDeliveryOptionData.shipping_label_id;
			orderDeliveryOption.shipping_label_offer_id = orderDeliveryOptionData.shipping_label_offer_id;
			orderDeliveryOption.recommended = orderDeliveryOptionData.recommended;
			orderDeliveryOption.valid_until_date = orderDeliveryOptionData.valid_until_date;
			orderDeliveryOption.transporter_code = orderDeliveryOptionData.transporter_code;
			orderDeliveryOption.label_type = orderDeliveryOptionData.label_type;
			orderDeliveryOption.label_display_name = orderDeliveryOptionData.label_display_name;
			orderDeliveryOption.label_price_total_price = orderDeliveryOptionData.label_price_total_price;
			orderDeliveryOption.package_max_weight = orderDeliveryOptionData.package_max_weight;
			orderDeliveryOption.package_max_dimensions = orderDeliveryOptionData.package_max_dimensions;
			orderDeliveryOption.handover_meets_expectation = orderDeliveryOptionData.handover_meets_expectation;
			orderDeliveryOption.handover_earliest = orderDeliveryOptionData.handover_earliest;
			orderDeliveryOption.handover_latest = orderDeliveryOptionData.handover_latest;
			orderDeliveryOption.handover_collection_method = orderDeliveryOptionData.handover_collection_method;

			order.delivery_options.push(orderDeliveryOption);
		});
	}

	if (orderData.order.eboekhoud) {
		order.eboekhoud = {};
		order.eboekhoud.contact_made = orderData.order.eboekhoud.contact_made;
		order.eboekhoud.invoice_made = orderData.order.eboekhoud.invoice_made;
		order.eboekhoud.invoice_send = orderData.order.eboekhoud.invoice_send;
	}

	if (orderData.order.moneybird) {
		order.moneybird = {};
		order.moneybird.contact_made = orderData.order.moneybird.contact_made;
		order.moneybird.invoice_made = orderData.order.moneybird.invoice_made;
		order.moneybird.invoice_send = orderData.order.moneybird.invoice_send;
	}

	return order;
}

mapper.mapLightspeed = (orderData) => {
	const order = {};

	order.order = {};
	order.order.id = orderData.order.id;
	order.order.type = orderData.order.type;
	order.order.type_id = orderData.order.lightspeed_order_id;
	order.order.type_id_visible = orderData.order.lightspeed_order_number;
	order.order.type_email_subject = `Bestelling ${order.order.type_id_visible}`;
	order.order.status = orderData.order.status;
	order.order.dropship = orderData.order.dropship;
	order.order.dropship_reference = orderData.order.dropship_reference;
	order.order.order_placed_date_time = orderData.order.order_placed_date_time;
	order.order.sendcloud = orderData.order.sendcloud;
	order.order.sendcloud_parcel_id = orderData.order.sendcloud_parcel_id;
	order.order.sendcloud_tracking = orderData.order.sendcloud_tracking;
	order.order.sendcloud_method = orderData.order.sendcloud_method;
	order.order.order_price = orderData.order.order_price;
	order.order.updated_at = orderData.order.updated_at;
	order.order.order_commission = orderData.order.order_commission;
	order.order.shipping_date = orderData.order.shipping_date;
	order.order.delivery_date = orderData.order.delivery_date;

	order.shipping = {};
	order.shipping.full_name = orderData.shipping.name;
	order.shipping.full_address = orderData.shipping.full_address;
	order.shipping.zip_code = orderData.shipping.zipcode;
	order.shipping.city = orderData.shipping.city;
	order.shipping.country_code = orderData.shipping.country_code;
	order.shipping.email = orderData.shipping.email;

	order.billing = {};
	order.billing.company = orderData.billing.company_name;
	order.billing.full_name = orderData.billing.name;
	order.billing.full_address = orderData.billing.full_address;
	order.billing.zip_code = orderData.billing.zipcode;
	order.billing.city = orderData.billing.city;
	order.billing.country_code = orderData.billing.country_code;
	order.billing.email = orderData.billing.email;

	order.items = [];

	orderData.items.forEach(orderItemData => {
		const orderItem = {};
		orderItem.id = orderItemData.id
		orderItem.ean = orderItemData.ean;
		orderItem.quantity = orderItemData.quantity_ordered;
		orderItem.unit_price = orderItemData.price_incl;
		orderItem.title = orderItemData.product_title;
		orderItem.reference = null;
		orderItem.location = orderItemData.offer_location;
		orderItem.package_id = orderItemData.offer_package_id;
		orderItem.unit_commission = 0;

		orderItem.cancellation_request = false;
		orderItem.cancellation_request_status = 0;

		order.items.push(orderItem);
	});

	if (orderData.order.eboekhoud) {
		order.eboekhoud = {};
		order.eboekhoud.contact_made = orderData.order.eboekhoud.contact_made;
		order.eboekhoud.invoice_made = orderData.order.eboekhoud.invoice_made;
		order.eboekhoud.invoice_send = orderData.order.eboekhoud.invoice_send;
	}

	if (orderData.order.moneybird) {
		order.moneybird = {};
		order.moneybird.contact_made = orderData.order.moneybird.contact_made;
		order.moneybird.invoice_made = orderData.order.moneybird.invoice_made;
		order.moneybird.invoice_send = orderData.order.moneybird.invoice_send;
	}

	return order;
}

export default mapper;
